<h3 mat-dialog-title>Enable Autopay for {{data.organization ? data.organization.name : ''}}</h3>

<mat-dialog-content>
    <!-- this shows if they haven't agreed to the auto pay terms yet -->
    <div *ngIf="isViewingTerms">
        <p>
            For each unpaid charge, we'll withdraw the payment from your bank account or credit card on the pay date
            (up to the maximum monthly payment amount that you set).
        </p>
        <p>
            The maximum monthly payment amount is per calendar month and will reset each month.
        </p>
        <p>
            The pay date is defined as the 'early payment discount date' or the 'due date' if no early payment
            discount exists.
        </p>
        <p>
            You will still receive notifications for new charges and monthly account invoices.
        </p>
        <p>
            Three business days before withdrawing the payment, we'll email you an auto-pay reminder that a
            charge is about to be paid.
        </p>
        <p>
            You can edit your auto-pay settings at any time by going to 'my account' and clicking 'auto-pay'.
        </p>
        <p>
            Auto-pay will not distinguish between different charge types or titles. Any charges added to
            your account will be automatically paid within your monthly maximum limits on the pay date.
        </p>
        <p>
            If a charge or charges exceeds your maximum monthly payment amount, auto-pay will apply the maximum
            monthly payment amount to the charge(s). If the charge is not fully paid due to insufficient maximum
            monthly payment amount, late fees will still apply where applicable.
        </p>
        <p>
            <b>Processing fees will not be included in the monthly maximum amount. Your total monthly maximum will be
                the
                amount set plus any applicable processing fees.</b>
        </p>
        <p>
            Charges will be paid in order of what is most outstanding.
        </p>


        <div>
            <mat-checkbox
                #agreedTermsCheck
                [name]="'agree-to-terms'"
                (change)="hasAgreedTerms = agreedTermsCheck.checked"
                [required]="true">
                I understand and agree to the Autopay Terms &amp; Conditions.
            </mat-checkbox>
        </div>

    </div>

    <!-- this shows once they have agreed to the auto pay terms (on set up, or if editing) -->
    <div *ngIf="!isViewingTerms">
        <form>
            <!--suppress HtmlUnknownAttribute -->
            <lf-payment-method-selector (modelChange)="paymentMethodChanged($event)"
                                        [ccSavable]="true"
                                        [doStackColumns]="true"
                                        [model]="paymentMethod"
                                        [organization]="data.organization"
                                        [showFeeNotification]="false"
                                        ngDefaultControl></lf-payment-method-selector>

            <div class="mt-4">
                <label class="mr-2">
                    Maximum Autopay Amount: *
                </label>

                <p class="form-text text-muted">
                    Please indicate the maximum amount you authorize to be auto-paid on your behalf.
                    Processing fees will not be included in the monthly maximum amount.  </p>

                <p *ngIf="paymentMethod && paymentMethod.type === 'CreditCard'
                        && data.organization.rates.merchantRate > 0 && !data.organization.profile.absorbsCcFees"
                   class="form-text text-muted">
                    Your total monthly maximum will be the
                    amount set, plus the {{data.organization.rates.merchantRate | number:'.0-2'}}%<span
                    *ngIf="data.organization.rates.merchantMinimum"> + {{data.organization.rates.merchantMinimum * 100}}&cent;</span>
                    credit card payment processing fees.
                </p>
                <p *ngIf="paymentMethod && paymentMethod.type === 'PaymentBankAccount'
                        && data.organization.rates.checkRateFlat > 0  && !data.organization.profile.absorbsAchFees"
                   class="form-text text-muted">
                    Your total monthly maximum will be the
                    amount set, plus
                    the  {{data.organization.rates.checkRateFlat * 100 | legfiCurrency:'USD':'symbol':'.2'}}
                    bank account payment processing fees.
                </p>

                <!-- TODO - convert to reactive form control type -->
                <lf-currency [(ngModel)]="autopayMax"
                             [ngModelOptions]="{standalone: true}"
                             [required]="true"
                             [name]="'autopay-max'"
                             [showSymbol]="true"></lf-currency>
            </div>

            <lf-form-messages [(message)]="formMessage.message"
                              [type]="formMessage.type"></lf-form-messages>
        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="btn btn-outline-secondary" [attr.aria-label]="'cancel'" mat-dialog-close>
        Cancel
    </button>

    <!-- button for first step, just toggles showing the 2nd view -->
    <button (click)="proceedIfAgree()" [disabled]="!hasAgreedTerms"
            *ngIf="isViewingTerms"
            class="btn btn-primary"
            [attr.aria-label]="'configure settings'"
            type="button">
        Configure settings &raquo;
    </button>

    <!--  button for second step, saves the changes and closes the modal -->
    <button (click)="saveAutopaySettings()"
            [disabled]="isSaveButtonDisabled"
            *ngIf="!isViewingTerms"
            [attr.aria-label]="'save autopay'"
            class="btn btn-primary"
            type="button">
        <i class="fa fa-check "></i>
        Save autopay settings
    </button>
</mat-dialog-actions>
